import React from "react";
import ToolbarCommon from "../toolbar/toolbar.common";
import { ApplicationContext } from "src/context";
import Icon from "src/components/icon";
import ToolbarLiveConditions from "src/modules/liveConditions/components/toolbar/toolbar.liveconditions";
import { isRunTime } from "src/utils/isRunTime";

export default class MobileToolbar extends ToolbarCommon {
    /** context: ApplicationContext */
    static contextType = ApplicationContext;
    /** @ts-ignore */
    context!: React.ContextType<typeof ApplicationContext>;

    private toolbarMobileRef = React.createRef<HTMLDivElement>();

    state = {
        initialPathname: null as string | null,
        ready: false,
    };

    componentDidMount() {
        super.componentDidMount?.();
        this.updateHeight();

        this.setState({
            initialPathname: isRunTime() ? window.location.pathname : null,
            ready: true,
        });
    }

    componentDidUpdate(prevProps: any) {
        // Recalculate height if display state changes
        if (prevProps.isScrollingUp !== this.props.isScrollingUp) {
            this.updateHeight();
        }
    }

    updateHeight = () => {
        if (!this.toolbarMobileRef.current || !this.context?.setHeaderHeight) return;
        
        // Use requestAnimationFrame to ensure DOM is fully rendered
        requestAnimationFrame(() => {
            const element = this.toolbarMobileRef.current;
            if (element) {
                const height = element.offsetHeight || 0;
                this.context.setHeaderHeight('toolbarMobile', height);
            }
        });
    }

    public get style(): any {
        const {toolbar} = this.props;
        return {
            '--text-color': toolbar.text_color?.value,
            '--hover-color': toolbar.hover_color?.value,
            '--background': toolbar.background_color?.value,

            '--dropdown-background': toolbar.dropdown_menu_background_color?.value || '#fff',
            '--dropdown-active-color': toolbar.text_color?.value,
            '--dropdown-text-color': toolbar.unselected_item_color?.value,
            '--dropdown-hover-color': toolbar.hover_color?.value,
        }
    }

    get display() {
        if (this.props.toolbar.mobile_toolbar_display === "fixed") {
            return "flex sticky";
        }
        if (this.props.toolbar.mobile_toolbar_display === "sticky") {
            return this.props.isScrollingUp ? "flex sticky" : "hidden";
        }
    }


    renderLiveConditions() {
        if (!this.props.toolbar.bars_live_conditions) return null;
        return (
            <ToolbarLiveConditions
                key="live-conditions"
                bars_live_conditions={this.props.toolbar.bars_live_conditions}
                language={this.props.language}
                defaultLanguage={this.props.defaultLanguage}
            />
        );
    }

    renderInAppBackButton() {
        if (!this.props.isInApp || !this.state.ready) return null;

        if (isRunTime() && window.location.pathname === this.state.initialPathname) {
            return null;
        }

        return (
            <button onClick={() => isRunTime() ? window.history.back() : null}>
                <Icon icon="ArrowLeft" className="w-5 h-5" />
            </button>
        );
    }

    get items() {
        let itemsToReturn: React.ReactNode[] = [];
        
        // Add live conditions first
        const liveConditions = this.renderLiveConditions();
        if (liveConditions) itemsToReturn.push(liveConditions);
        
        if (!this.props.isInApp) itemsToReturn.push(...this.props.toolbar.items.filter(item => item.item.mobile_fixed_at_top === true).map((item, index) => this.renderToolbarItem(item, index)));
        
        if (this.props.toolbar.with_currency_selector && this.props.toolbar.currency_selector_fixed_at_top && !this.props.isInApp) {
            itemsToReturn.push(this.renderCurrencyPicker());
        }
        if (this.props.toolbar.with_language_selector && this.props.toolbar.language_selector_fixed_at_top && !this.props.isInApp) {
            itemsToReturn.push(this.renderLanguagePicker());
        }
        if (this.props.toolbar.user_profile && this.props.toolbar.user_profile_fixed_at_top) {
            itemsToReturn.push(this.renderMyAccount());
        }
        if (this.props.toolbar.shopping_cart && this.props.toolbar.shopping_cart_fixed_at_top) {
            itemsToReturn.push(this.renderCart());
        }
        
        return itemsToReturn;
    }

    public render() {
        if (this.items.length === 0 && !this.props.isInApp) return null;
        // const heightClass = this.props.scrolledDown ? 'h-[40px]' : 'h-[56px]';
        const heightClass = 'h-[40px]';

        return <div ref={this.toolbarMobileRef} id="toolbar-mobile" className={`${this.display} w-full lg:hidden top-0 z-[101] px-[24px] toolbar ${heightClass} bg-[color:var(--background)] ${this.shadow}`} style={this.style}>
            {this.props.isInApp ? this.renderInAppBackButton() : null}
            <div className="mx-auto w-full max-w-7xl flex flex-row items-center justify-end relative gap-4">
                {this.items}
            </div>
        </div>
    }
}